import { useEffect, useState } from 'react';
import { cuentaYPermisos } from '../lib/permisosDelEquipo';
import { useUltimoSaldo } from './useSaldo';

/**
 * ¿"Añadir nueva marca" está cerrado para esta persona? Sólo con facturación por marca y para
 * quien no es el dueño de la cuenta (ADR-2026-10-28-marca-nueva-con-pago): cada marca paga su
 * plan y el que paga es el dueño. Sin la bandera es siempre `false` y no consulta nada.
 *
 * Es para DIBUJAR el botón deshabilitado con el motivo (`MOTIVO_SOLO_ADMIN`); el click igual lo
 * decide `decidirMarcaNueva`, que no depende de que esto ya haya cargado.
 */
export function useMarcaNuevaSoloAdmin(): boolean {
  const porMarca = useUltimoSaldo()?.facturaPorMarca === true;
  const [esDueno, setEsDueno] = useState<boolean | null>(null);
  useEffect(() => {
    if (!porMarca) return;
    let vivo = true;
    cuentaYPermisos()
      .then((c) => vivo && setEsDueno(c.esDueno))
      .catch(() => vivo && setEsDueno(false));
    return () => {
      vivo = false;
    };
  }, [porMarca]);
  return porMarca && esDueno === false;
}

export default useMarcaNuevaSoloAdmin;
